<script>
import axios from '@/utils/axios';
import { paymentGateway } from '@/utils/app-store';

export default {
 inject: ['setLoading'], 
  data() {
   return {
    errors: {},
    title: "Settings",
    text: "Administration",
    text1: "Settings",
    currencies: [],
    gmail_status: '',
    webmail_status: '',
    indiamart_status: '',
    tradeindia_status: '',
    justdial_status: '',
    exportersindia_status: '',
    default_mailer: '',
    razorpay_status: '',
    zoho_status: '',
    twilio_status: '',
    msg91_status: '',
    meta_status: '',
    aajjo_status: '',
    default_communication: '',
   };
 },

 mounted(){
  this.loadAppStatus();
 },

 methods: {

  loadAppStatus(){ 
   this.mailerStatus();
   this.defaultMailer();
   this.importConfigStatus();
   this.paymentGatewayStatus();
   this.defaultCommunication();
   this.accountingConfigStatus();
   this.communicationConfigStatus();
  },

  async mailerStatus(){
   try{
    const response = await axios.get(`/mail-configurations/status`);
    const data = response.data.data;
    this.gmail_status = data.gmail;
    this.webmail_status = data.webmail;
   }catch(error){
    this.$swalToast(error.message, 'error');
   } 
  },

  async defaultMailer(){
   try{
    const response = await axios.get(`/mail-configurations/default`);
    this.default_mailer = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   } 
  },

  async setDefaultMailer(provider){
   const result = await this.$confirm({text: "This will be set as default mailer!",});
   if(result.isConfirmed){ 
    try{
     const response = await axios.patch(`mail-configurations/${provider}/set-default`);
     this.$swalToast(response.data.message);
     this.loadAppStatus();
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   } 
  },

  async importConfigStatus(){
   try{
    const response = await axios.get(`/lead-import-configs/status`);
    const data = response.data.data;
    this.indiamart_status = data.IndiaMART;
    this.tradeindia_status = data.TradeIndia;
    this.justdial_status = data.Justdial;
    this.exportersindia_status = data.ExportersIndia;
    this.aajjo_status = data.Aajjo;
   }catch(error){
    //this.$swalToast(error.message, 'error');
   } 
  },

  async accountingConfigStatus(){
   try{
    const response = await axios.get(`/accounting-configs/status`);
    const data = response.data.data;
    this.zoho_status = data.zoho_books;
   }catch(error){
    //this.$swalToast(error.message, 'error');
   } 
  },

  async communicationConfigStatus(){
   try{
    const response = await axios.get(`/communication-configs/status`);
    const data = response.data.data;
    this.twilio_status = data.twilio;
    this.msg91_status = data.msg91;
    this.meta_status = data.meta;
    this.prasar_ai_status = data.prasar_ai;
   }catch(error){
    //this.$swalToast(error.message, 'error');
   } 
  },

  async defaultCommunication(){
   try{
    const response = await axios.get(`/communication-configs/default`);
    this.default_communication = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   } 
  },

  async setDefaultCommunication(provider){
   const result = await this.$confirm({text: "This will be set as default communication provider of WhatsApp or SMS !",});
   if(result.isConfirmed){ 
    try{
     const response = await axios.patch(`communication-configs/${provider}/set-default`);
     this.$swalToast(response.data.message);
     this.loadAppStatus();
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   } 
  },

  async paymentGatewayStatus(){
   try{
    const data = await paymentGateway();
    this.razorpay_status = data.Razorpay;
   }catch(error){
    this.$swalToast(error.message, 'error');
   } 
  }

 },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="head-icons ms-2">
 
</div>
</div>
<!-- /Breadcrumb -->

<settings-tab></settings-tab>
<div class="row">
<app-sidebar></app-sidebar>
<div class="col-xl-9">
<div class="card">
<div class="card-body pb-1">
<div class="border-bottom mb-3 pb-3">
 <h4>All Apps</h4>
</div>

<div class="row">

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/gmail.png" alt="Gmail" width="50" /></span>
<div class="d-flex align-items-center">
 <div class="status-toggle modal-status">
  <button type="button" class="btn btn-xs btn-primary" @click="setDefaultMailer('gmail')" v-if="gmail_status === 'Connected' && default_mailer !== 'gmail'"><i class="ti ti-circle-dot me-2"></i>Set as default</button>
  <span class="badge bg-success" v-if="default_mailer === 'gmail'"><i class="ti ti-checks me-2"></i>Default</span>
</div>
</div>
</div>
<div class="card-body pt-0">
<p>
Gmail is a free Google service to send emails, organize your inbox, and connect with tools like Drive and Calendar.
</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="gmail_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{gmail_status}}</span>
 <span class="badge bg-danger" v-if="gmail_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{gmail_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_mailer" @click="$refs.appStoreModal.mailer('gmail')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/imap.png" alt="IMAP/SMTP" width="50" /></span>
<div class="d-flex align-items-center">
 <div class="status-toggle modal-status">
  <button type="button" class="btn btn-xs btn-primary" @click="setDefaultMailer('webmail')" v-if="gmail_status === 'Connected' && default_mailer !== 'webmail'"><i class="ti ti-circle-dot me-2"></i>Set as default</button>
  <span class="badge bg-success" v-if="default_mailer === 'webmail'"><i class="ti ti-checks me-2"></i>Default</span>
</div>
</div>
</div>
<div class="card-body pt-0">
<p>
Webmail is an email service you can use directly in a web browser to send, receive, and manage emails.
</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="webmail_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{webmail_status}}</span>
 <span class="badge bg-danger" v-if="webmail_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{webmail_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_mailer" @click="$refs.appStoreModal.mailer('webmail')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/indiamart.png" alt="IndiaMART" width="60" /></span>
<div class="d-flex align-items-center">
 <!-- <div class="status-toggle modal-status">
  <input type="checkbox" id="user1" class="check" />
  <label for="user1" class="checktoggle"> </label>
</div> -->
</div>
</div>
<div class="card-body pt-0">
<p>
IndiaMART is a leading online marketplace connecting buyers and suppliers across various industries.
</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="indiamart_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{indiamart_status}}</span>
 <span class="badge bg-danger" v-if="indiamart_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{indiamart_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_import_config" @click="$refs.appStoreModal.importConfig('IndiaMART')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/tradeindia.png" alt="TradeIndia" width="60" /></span>
<div class="d-flex align-items-center">
 <!-- <div class="status-toggle modal-status">
  <input type="checkbox" id="user1" class="check" />
  <label for="user1" class="checktoggle"> </label>
</div> -->
</div>
</div>
<div class="card-body pt-0">
<p>
TradeIndia is a B2B marketplace that connects businesses with buyers and sellers across industries.
</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="tradeindia_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{tradeindia_status}}</span>
 <span class="badge bg-danger" v-if="tradeindia_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{tradeindia_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_import_config" @click="$refs.appStoreModal.importConfig('TradeIndia')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/justdial.png" alt="Justdial" width="70" height="70" /></span>
<div class="d-flex align-items-center">
 <!-- <div class="status-toggle modal-status">
  <input type="checkbox" id="user1" class="check" />
  <label for="user1" class="checktoggle"> </label>
</div> -->
</div>
</div>
<div class="card-body pt-0">
<p>
Justdial is a local search platform in India that connects users with nearby businesses, services, and products.
</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="justdial_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{justdial_status}}</span>
 <span class="badge bg-danger" v-if="justdial_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{justdial_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_import_config" @click="$refs.appStoreModal.importConfig('Justdial')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/exportersindia.png" alt="ExportersIndia" width="90" /></span>
<div class="d-flex align-items-center">
 <!-- <div class="status-toggle modal-status">
  <input type="checkbox" id="user1" class="check" />
  <label for="user1" class="checktoggle"> </label>
</div> -->
</div>
</div>
<div class="card-body pt-0">
<p>
ExportersIndia is a B2B marketplace that connects buyers with exporters, suppliers, and manufacturers in India.
</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="exportersindia_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{exportersindia_status}}</span>
 <span class="badge bg-danger" v-if="exportersindia_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{exportersindia_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_import_config" @click="$refs.appStoreModal.importConfig('ExportersIndia')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>
<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/aajjo.webp" alt="Aajjo" width="70" /></span>
<div class="d-flex align-items-center">
</div>
</div>
<div class="card-body pt-0">
<p>
Aajjo is a B2B marketplace connecting manufacturers, suppliers, and buyers across India for business growth.
</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="aajjo_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{ aajjo_status }}</span>
 <span class="badge bg-danger" v-if="aajjo_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{ aajjo_status }}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_import_config" @click="$refs.appStoreModal.importConfig('Aajjo')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/razorpay.png" alt="Razorpay" width="90" /></span>
<div class="d-flex align-items-center">
 <!-- <div class="status-toggle modal-status">
  <input type="checkbox" id="user1" class="check" />
  <label for="user1" class="checktoggle"> </label>
</div> -->
</div>
</div>
<div class="card-body pt-0">
<p>
Razorpay is a fast and secure online payment gateway that helps businesses accept and manage payments with ease.
</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="razorpay_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{razorpay_status}}</span>
 <span class="badge bg-danger" v-if="razorpay_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{razorpay_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_payment_gateway_config" @click="$refs.appStoreModal.paymentGatewayConfig('Razorpay')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/zoho.png" alt="Zoho Books" width="90" /></span>
<div class="d-flex align-items-center">
 <!-- <div class="status-toggle modal-status">
  <input type="checkbox" id="user1" class="check" />
  <label for="user1" class="checktoggle"> </label>
</div> -->
</div>
</div>
<div class="card-body pt-0">
<p>Our CRM is being enhanced with Zoho integration to streamline business operations, improve collaboration, and support confident scaling.</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="zoho_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{zoho_status}}</span>
 <span class="badge bg-danger" v-if="zoho_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{zoho_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_accounting_config" @click="$refs.appStoreModal.accountingConfig('zoho_books')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/twilio.png" alt="Twilio" width="90" /></span>
<div class="d-flex align-items-center">
 <div class="status-toggle modal-status">
  <button type="button" class="btn btn-xs btn-primary" @click="setDefaultCommunication('twilio')" v-if="twilio_status === 'Connected' && default_communication !== 'twilio'"><i class="ti ti-circle-dot me-2"></i>Set as default</button>
  <span class="badge bg-success" v-if="default_communication === 'twilio'"><i class="ti ti-checks me-2"></i>Default</span>
</div>
</div>
</div>
<div class="card-body pt-0">
<p>Seamless Twilio integration enabling WhatsApp, SMS, voice calls, and communication to improve engagement and efficiency.</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="twilio_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{twilio_status}}</span>
 <span class="badge bg-danger" v-if="twilio_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{twilio_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_communication_config" @click="$refs.appStoreModal.communicationConfig('twilio')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/msg91.png" alt="MSG91" width="90" /></span>
<div class="d-flex align-items-center">
 <div class="status-toggle modal-status">
  <button type="button" class="btn btn-xs btn-primary" @click="setDefaultCommunication('msg91')" v-if="msg91_status === 'Connected' && default_communication !== 'msg91'"><i class="ti ti-circle-dot me-2"></i>Set as default</button>
  <span class="badge bg-success" v-if="default_communication === 'msg91'"><i class="ti ti-checks me-2"></i>Default</span>
 </div>
</div>
</div>
<div class="card-body pt-0">
<p>MSG91 integration for secure OTP, promotional and transactional messaging, ensuring fast delivery, and improved reach across channels.</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="msg91_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{msg91_status}}</span>
 <span class="badge bg-danger" v-if="msg91_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{msg91_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_communication_config" @click="$refs.appStoreModal.communicationConfig('msg91')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

<div class="col-xxl-6 col-xl-6 d-flex">
<div class="card mb-3 flex-fill">
<div class="card-header d-flex align-items-center justify-content-between border-0 mb-3 pb-0">
<span class="d-inline-flex align-items-center justify-content-center border rounded p-2">
 <img src="@/assets/img/app/prasar-ai.png" alt="PrasarAI" width="90" /></span>
<div class="d-flex align-items-center">
 <div class="status-toggle modal-status">
  <button type="button" class="btn btn-xs btn-primary" @click="setDefaultCommunication('prasar_ai')" v-if="prasar_ai_status === 'Connected' && default_communication !== 'prasar_ai'"><i class="ti ti-circle-dot me-2"></i>Set as default</button>
  <span class="badge bg-success" v-if="default_communication === 'prasar_ai'"><i class="ti ti-checks me-2"></i>Default</span>
 </div>
</div>
</div>
<div class="card-body pt-0">
<p>Prasar AI helps businesses automate and scale WhatsApp messaging with intelligent AI that handles customer chats, follow-ups, lead qualification, and support.</p>
</div>
<div class="card-footer d-flex align-items-center justify-content-between">

 <span class="badge bg-secondary" v-if="prasar_ai_status === 'Connected'"><i class="ti ti-checks me-2"></i>{{prasar_ai_status}}</span>
 <span class="badge bg-danger" v-if="prasar_ai_status === 'Disconnected'"><i class="ti ti-alert-triangle me-2"></i>{{prasar_ai_status}}</span>

 <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#app_store_communication_config" @click="$refs.appStoreModal.communicationConfig('prasar_ai')"><i class="ti ti-settings fs-24 fw-normal"></i></a>

</div>
</div>
</div>

</div>
</div>
</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<app-store-modal ref="appStoreModal" @updated="loadAppStatus"></app-store-modal>
</template>